import { Link } from "react-router-dom";
import type { Character } from "@/mocks/characters";

const roleStyle: Record<Character["role"], string> = {
  主角: "bg-primary-100 text-primary-800",
  配角: "bg-secondary-100 text-secondary-800",
  反派: "bg-foreground-900 text-background-50",
};

export default function CharacterCard({ character, index = 0 }: { character: Character; index?: number }) {
  return (
    <Link
      to={`/character/${character.id}`}
      className="group block rounded-lg bg-background-50 border border-background-200 overflow-hidden hover:border-accent-300 transition-colors cursor-pointer animate-fade-up"
      style={{ animationDelay: `${Math.min(index, 9) * 45}ms` }}
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-200">
        <img
          src={character.avatar}
          alt={`${character.name} 角色立绘`}
          title={`甜蜜惩罚 角色 ${character.name}`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className={`absolute top-2 left-2 px-2 py-0.5 rounded-md text-xs font-label ${roleStyle[character.role]}`}>
          {character.role}
        </span>
      </div>
      <div className="p-4">
        <h3 className="font-heading text-base text-foreground-950 mb-1 group-hover:text-primary-700 transition-colors">
          {character.name}
        </h3>
        <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 font-label">{character.tagline}</p>
      </div>
    </Link>
  );
}